import { generateClient } from 'aws-amplify/api'
import { getCurrentUserDetails as getCurrentUserDetailsQuery } from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export async function getCurrentUserDetailsRequest() {
  try {
    const { data, errors } = await client.graphql({
      query: getCurrentUserDetailsQuery,
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data.getCurrentUserDetails)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to load account details'),
    }
  }
}
